import { MyApprovalRequestType, MyApprovalRequestTypes } from "./data.type";

const setLimit = (limit: number): MyApprovalRequestType => ({
  type: MyApprovalRequestTypes.SET_LIMIT,
  payload: { limit },
});

const setLastDays = (lastDays: number): MyApprovalRequestType => ({
  type: MyApprovalRequestTypes.SET_LAST_DAYS,
  payload: { lastDays },
});

const setRequestor = (requestor: string): MyApprovalRequestType => ({
  type: MyApprovalRequestTypes.SET_REQUESTOR,
  payload: { requestor },
});

const setContext = (context: number[]): MyApprovalRequestType => ({
  type: MyApprovalRequestTypes.SET_CONTEXT,
  payload: { context },
});

const setStatus = (status: string[]): MyApprovalRequestType => ({
  type: MyApprovalRequestTypes.SET_STATUS,
  payload: { status },
});

const setSearch = (search: string): MyApprovalRequestType => ({
  type: MyApprovalRequestTypes.SET_SEARCH,
  payload: { search },
});

const setFilterApplied = (
  hasFilterApplied: boolean,
): MyApprovalRequestType => ({
  type: MyApprovalRequestTypes.SET_FILTER_APPLIED,
  payload: { hasFilterApplied },
});

const setOffset = (offset: number): MyApprovalRequestType => ({
  type: MyApprovalRequestTypes.SET_OFFSET,
  payload: { offset },
});

const setDataResults = (dataResults: any): MyApprovalRequestType => ({
  type: MyApprovalRequestTypes.SET_DATA_RESULTS,
  payload: { dataResults },
});

export const MyApprovalActions = {
  setLimit,
  setLastDays,
  setRequestor,
  setContext,
  setStatus,
  setSearch,
  setFilterApplied,
  setOffset,
  setDataResults,
};
